var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray");

var _toArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toArray");

var resolveConfigObjects = require('./lib/util/resolveConfig').default;

var getAllConfigs = require('./lib/util/getAllConfigs').default;

module.exports = function resolveConfig() {
  for (var _len = arguments.length, configs = new Array(_len), _key = 0; _key < _len; _key++) {
    configs[_key] = arguments[_key];
  }

  var _getAllConfigs = getAllConfigs(configs[0]),
      _getAllConfigs2 = _toArray(_getAllConfigs),
      defaultConfigs = _getAllConfigs2.slice(1);

  return resolveConfigObjects([].concat(configs, _toConsumableArray(defaultConfigs)));
};